import { SET_LOADING } from "./constants";

const initialState = {
    loaders: {
        siteLoading: false,
    },
};

function loaders(state = initialState.loaders, { type, payload }) {
    if (type === SET_LOADING) {
        const loader = {[`${payload.scope}`]: payload.flag};
        return {...state, ...loader};
    }

    return state;
}

export default loaders;